<template>
  <div id="body_ATG"  v-if="newAllBetEvent.od[plytyp] && newAllBetEvent.od[plytyp][atgBetType]">
    <!------------------------ ATG ------------------------>
    <table id="model_ATG" border="0" cellpadding="0" cellspacing="0" class="more_table2">
      <tbody>
        <!--tr style="height:2px"><td class="emptyrow"  :class="{isrb: newAllBetEvent.event_rb==1}"  colspan="2"></td></tr-->
        <template v-for="(subMatch, subMatchKey) in (Object.keys(newAllBetEvent.od[plytyp][atgBetType]).length)">
          <template v-if="newAllBetEvent.od[plytyp][atgBetType][Object.keys(newAllBetEvent.od[plytyp][atgBetType])[subMatchKey]]">
            <template v-if="newAllBetEvent.od[plytyp][atgBetType][Object.keys(newAllBetEvent.od[plytyp][atgBetType])[subMatchKey]]['hdp'] != 0">
              <tr v-if="subMatchKey == 0">
                <th class="more_title4" colspan="2"  @click="showLeg()">
                  <button id="triggertoggle" class="trigger toggle-primary" :class="show ? 'icon-open' : 'icon-close'"></button>
                  <template v-if="plytyp == gameHdpPlyType">
                    <span class="btheader">&nbsp;{{ sportAllBetLang['ALL_BET.SUBHEADER_TOTAL_GAME'] }}</span>
                  </template>
                  <template v-else-if="plytyp == setHandicapPlyType">
                    <span class="btheader">&nbsp;{{ sportAllBetLang['ALL_BET.SUBHEADER_SET_HDP_FRONT'] }}</span>
                  </template>
                  <template v-else-if="plytyp == pointHdpPlyType">
                    <span class="btheader">&nbsp;{{ sportAllBetLang['ALL_BET.SUBHEADER_POINT_HDP_FRONT'] }}</span>
                  </template>

                  <span class="btheader">{{ oddsHeader() }}{{ sportAllBetLang['ALL_BET.ATG'] }}</span>

                  <template v-if="plytyp == firstHtPlyType">
                    <span class="more_og2">&nbsp;{{ sportAllBetLang['ALL_BET.SUBHEADER_1HT'] }}</span>
                  </template>
                </th>
              </tr>
              <template v-if="show">
                <template v-if="subMatchKey == 0">
                  <tr>
                    <th class="allbetheader header" width="50%">  
                      <div class="more_font" :title="sportAllBetLang['ALL_BET.LBL_OVER']">
                        <span class=""> {{ sportAllBetLang['ALL_BET.LBL_OVER'] }} ({{ newAllBetEvent.od[plytyp][atgBetType][Object.keys(newAllBetEvent.od[plytyp][atgBetType])[subMatchKey]]['hdp'] }})</span>
                      </div>
                    </th>
                    <th class="allbetheader header" width="50%">  
                      <div class="more_font" :title="sportAllBetLang['ALL_BET.LBL_UNDER']">
                        <span class=""> {{ sportAllBetLang['ALL_BET.LBL_UNDER'] }}  ({{ newAllBetEvent.od[plytyp][atgBetType][Object.keys(newAllBetEvent.od[plytyp][atgBetType])[subMatchKey]]['hdp'] }})</span>
                      </div>
                    </th>
                  </tr>
                </template>
                <tr :class="{more_white: subMatchKey % 2 == 0, more_color: subMatchKey % 2 != 0}">
                  <td class="cursorcontent allbetcontent abcs" :class="{isrb: newAllBetEvent.event_rb==1}"  style="cursor:pointer" width="50%" @click="selectCell($event,'teamOver'+subMatchKey)">
                    <div class="betArea" style="margin:auto;width:200px">
                      <span class="" :title="sportAllBetLang['ALL_BET.LBL_OVER']">
                        <odd :event="newAllBetEvent" :team="teamA" :plyType="plytyp" :betType="atgBetType" :match="subMatchKey" :ref="'teamOver'+subMatchKey"/>
                      </span>
                    </div>
                  </td>
                  <td class="cursorcontent allbetcontent abcs" :class="{isrb: newAllBetEvent.event_rb==1}"  style="cursor:pointer" width="50%" @click="selectCell($event,'teamUnder'+subMatchKey)">
                    <div class="betArea" style="margin:auto;width:200px">
                      <span class="" :title="sportAllBetLang['ALL_BET.LBL_UNDER']">
                        <odd :event="newAllBetEvent" :team="teamB" :plyType="plytyp" :betType="atgBetType" :match="subMatchKey" :ref="'teamUnder'+subMatchKey"/>
                      </span>
                    </div>
                  </td>
                </tr>
              </template>
            </template>
          </template>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>

  import OddComponents from '../../../components/odd'
  import OverUnderComponents from '../../../components/over-under'

  import allBetMixin from '../../../mixins/allBet'

  export default {
    mixins: [allBetMixin],
    props: {
      allBetEvent : null,
      plytyp: null,
      selectMarket: null,
      removeMarket: null,
      rbinfo: null,
      myMarket: {
        type: Boolean,
        default: false
      },
      isSpecial: {
        type: Boolean,
        default: false
      },
    },
    data() {
        return {
            btypes: [allBetMixin.data().atgBetType, allBetMixin.data().ratgBetType],
            show: true,
        }
    },
    computed: {
      newAllBetEvent () {
        return this.allBetEvent
      }
    },
    methods: {
      showLeg() {
        this.show = (!this.show) ? true : false;
      },
      addToMyMarket(plytyp,atgBetType) {
        if(this.selectMarket)
          this.selectMarket(this.newAllBetEvent, plytyp, atgBetType, this.isSpecial)
      },
      removeFromMyMarket(plytyp,atgBetType) {
        if(this.removeMarket)
          this.removeMarket(this.newAllBetEvent, plytyp, atgBetType, this.isSpecial)
      },
      oddsHeader() {
        var retCapt = ''
        
        retCapt += this.specialLeagueCaption(this.newAllBetEvent, this.atgBetType)
        
        return retCapt
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBet/all-bet-atg.vue